import React from "react";
import brandLogoInvert from "../../assets/images/brand_logo_invert.png";
import { loggedInUrl } from "../../bridges/deeplinkUrlConfig";

const LoginHeader = () => {
  return (
    <div className="login-header">
      <a href="/">
        <img
          src={brandLogoInvert}
          alt="brand-logo"
          className="brand-logo"
        />
      </a>
      <a href={loggedInUrl} className="login-link">
        LOGIN
      </a>
    </div>
  );
};

export default LoginHeader;
